import { APICore } from './apiCore';

const api = new APICore();

interface UserData {
    name: string;
    email: string;
    role: string;
}

export function getUser(userId: number) {
    const baseUrl = `/user/${userId}`;
    return api.get(baseUrl);
}
export function getAllUser(companyId: string) {
    const baseUrl = `/user/all/${companyId}`;
    return api.get(baseUrl);
}

export function createUser(userData: UserData) {
    const baseUrl = '/user/add';
    return api.create(baseUrl, userData);
}

export function updateUser(userId: number, userData: UserData) {
    const baseUrl = `/user/${userId}`;
    return api.update(baseUrl, userData);
}

export function deleteUser(userId: number) {
    const baseUrl = `/user/${userId}`;
    return api.delete(baseUrl);
}
